import { CategoryInfo } from "../../store/slice/productsSlice";
import "./Tags.scss";

const Tags = ({
  tags,
  onClick,
}: {
  tags?: CategoryInfo[];
  onClick?: (tag: CategoryInfo) => void;
}) => {
  return (
    <div className="tags">
      {tags?.map((tag, idx) => (
        <span key={`${tag.name}-${idx}`} onClick={() => onClick?.(tag)}>
          {tag.name}
        </span>
      ))}
    </div>
  );
};

export default Tags;
